<template>
    <div class="CustomHeader">
        <van-sticky>
            <van-nav-bar :style="{ backgroundColor: bgColor }" :title="title" @click-left="clickleft" @click-right="clickRight" left-arrow>
                <template #left
                    ><span class="leftArea" :style="{ color }"><van-icon :color="color" size="20" :name="leftIcon" />{{ leftText }}</span></template
                >
                <template @click-right="onClickRight" #right>
                    {{ rightText }}
                </template>
            </van-nav-bar>
        </van-sticky>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        leftIcon: {
            type: String,
            default: "arrow-left",
        },
        leftText: {
            type: String,
            default: "返回",
        },
        color: {
            type: String,
            default: "#333",
        },
        bgColor: {
            type: String,
            default: "#fff",
        },
        rightText: {
            type: String,
            default: "",
        },
    },
    methods: {
        clickleft() {
            if (this.$listeners.clickLeft) {
                this.$emit("clickLeft");
            } else {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push("/");
                }
            }
        },
        clickRight() {
            this.$emit("clickRight");
        },
    },
};
</script>

<style lang="scss" scoped>
.CustomHeader {
    .leftArea {
        display: flex;
    }
}
</style>
